import { css } from '@/styled-system/css';

export const poiTypeComboboxContainer = css({
  width: '100%',
  minWidth: 0,
});

export const poiTypeComboboxRoot = css.raw({
  width: '100%',
});
